import { createSlice } from "@reduxjs/toolkit"
import type { RootState } from "../store"

interface RateLimitSliceState {
	rateLimitedUntil: number | null
}

export const rateLimitSlice = createSlice({
	name: "rateLimit",
	initialState: {
		rateLimitedUntil: null,
	} as RateLimitSliceState,
	reducers: {
		setRateLimited(state, { payload }: { payload: number | null }) {
			state.rateLimitedUntil = payload
		},
	},
	selectors: {},
})

export const { setRateLimited } = rateLimitSlice.actions
export const rateLimitSelector = (state: RootState) => state.rateLimit
